@use '../../styling/form-controls.scss' as *;
@use '../../styling/colors.scss' as *;

.LabeledRadioWithText {
  @extend %form-control-font;

  display: inline-flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: $theme-color-input-readonly;
  cursor: pointer;

  &.fixedWidth {
    min-width: 116px;
    max-width: 136px;
  }

  &.isChecked {
    border: 1px solid $color-primary-purple;
  }

  &:hover {
    background: $theme-color-secondary-button-hover;
  }

  .buttonWrapper {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
  }

  .labelWrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 0;
  }

  &.Disabled {
    cursor: default;
    background: $theme-color-radio-disabled-background;
    color: $theme-color-tab-label-unselected;
  }

  &.isCheckedAndIsDisabled {
    border: 1px solid $color-primary-purple-50;
  }

  &.isFullWidth {
    max-width: none;
  }

  &.isRemoveGap {
    gap: 0;
  }
}
